// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import 'mint-ui/lib/style.css'
import Mint from 'mint-ui';
Vue.use(Mint);

import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.prototype.$axios = axios;

Vue.config.productionTip = false
import 'lib-flexible'

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'  //引入样式(swiper5的引入css)
Vue.use(VueAwesomeSwiper)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)

Vue.prototype.$layer = layer(Vue);

import bridge from './config/client'
Vue.prototype.$bridge = bridge;

import mixins from '@/mixins/index'
Vue.mixin(mixins);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js